import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import FieldLabel from './FieldLabel'

const RadioButton = ({
    label,
    value,
    disabled = false,
}) => (
    <FormControlLabel
        label={(
            <Typography
                sx={{ color: disabled ? '#9e9e9e' : '#161832', fontSize: '1rem' }}
            >
                {label}
            </Typography>
        )}
        value={value}
        control={<Radio sx={{ padding: '5px' }}/>}
        disabled={disabled}
    />
)

RadioButton.propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
}

const NewRadioButtons = ({
    label,
    value,
    items = [],
    onChange = () => {},

    row = true,
    required = false,
    disabled = false,
}) => {
    return (
        <FormControl>
            {!!label && <FieldLabel label={label} required={required} />}
            <RadioGroup
                row={row}
                value={value}
                onChange={(_, newV) => {
                    const parseV = parseInt(newV)
                    onChange(isNaN(parseV) ? newV : parseV)
                }}
            >
                {items.map(item => (<RadioButton key={item.value} value={item.value} label={item.label} disabled={disabled} />))}
            </RadioGroup>
        </FormControl>
    )
}

NewRadioButtons.propTypes = {
    row: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    items: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string,
    })),
    onChange: PropTypes.func,

    required: PropTypes.bool,
    disabled: PropTypes.bool,
}

export default NewRadioButtons